<template>
  <CCard>
    <CCardHeader>
      <strong style="line-height: 2.3">온실 환경 정보</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol col="12" md="8">
          <div
            ref="inEnvChart"
            style="width: 100%; height: 250px; margin: auto 0"
            :class="chart == null || chart.data.length === 0 ? 'd-none' : ''"
          ></div>
          <div
            style="
              width: 100%;
              height: 250px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              text-align: center;
              font-weight: bold;
              font-size: 150%;
              color: #ff0d0d;
            "
            v-if="chart == null || chart.data.length === 0"
          >
            <div>
              <i class="fa fa-times-circle" aria-hidden="true"></i>
              데이터 없음
            </div>
          </div>
        </CCol>
        <CCol col="12" md="4">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-12 col-lg-12">
              <span class="text"
              >누적 일사
                <span class="pull-right">130777/240000 </span>
              </span>
              <div class="progress">
                <div
                  class="progress-bar bg-color-blueDark"
                  style="width: 65%"
                ></div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-12 col-lg-12">
              <span class="text">
                적산온도
                <span class="pull-right">440 </span>
              </span>
              <div class="progress">
                <div
                  class="progress-bar bg-color-blue"
                  style="width: 34%"
                ></div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-12 col-lg-12">
              <span class="text"
              >생산예측
                <span class="pull-right">77%</span>
              </span>
              <div class="progress">
                <div
                  class="progress-bar bg-color-blue"
                  style="width: 77%"
                ></div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-12 col-lg-12">
              <span class="text"
              >생육기간
                <span class="pull-right">107 Days</span>
              </span>
              <div class="progress">
                <div
                  class="progress-bar bg-color-greenLight"
                  style="width: 84%"
                ></div>
              </div>
            </div>
          </div>

          <CRow class="mt-2 pl-2 pr-2">
            <CCol col="12" xl="4" class="p-1">
              <CButton color="danger" class="w-100">추천제어</CButton>
            </CCol>
            <CCol col="12" xl="4" class="p-1">
              <CButton color="success" class="w-100">자동제어</CButton>
            </CCol>
            <CCol col="12" xl="4" class="p-1">
              <CButton color="primary" class="w-100">사용자제어</CButton>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import core from "@/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "InEnvChartCard",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      chart: null,
      refId: "inEnvChart",
      sensorList: store.state.app.constant.sensor.inEnvList,
    };
  },
  created() {
  },
  mounted() {
  },
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
  },
  methods: {
    init() {
      if (this.chart == null) {
        this.createChart();
      }
      this.chart.data = [];
    },
    redraw() {
      if (this.chart == null) {
        this.createChart();
      }
      const list = this.properties.inEnvList;

      let lastDate = core.date.instance();
      const dataList = this.getFilterDataList(list, lastDate);
      const avgList = this.getAvgDataList(dataList);
      console.log("avgList : ", avgList);
      this.chart.data = avgList;
    },
    createChart() {
      const $el = this.$refs[this.refId];
      const chart = core.amchart.createXYDateChart($el);

      const dateFieldName = "date";

      let toggle = false;
      this.sensorList.forEach((sensor) => {
        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        const series = core.amchart.createLineSeries(
          chart,
          sensor.fieldName,
          dateFieldName,
          sensor.label,
          sensor.colorHex,
          sensor.unit,
        );
        series.fillOpacity = 0.1;
        series.yAxis = valueAxis;
        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = toggle;
        toggle = !toggle;
      });

      chart.cursor = new am4charts.XYCursor();
      // chart.scrollbarX = scrollbarX;
      chart.data = [];
      this.chart = chart;
    },
  },
};
</script>
